import { ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementDefaultsPage } from "../WasteMovementDefaultsPage/WasteMovementDefaultsPage";

const WasteRemovedDefaultsPage = () => (
    <WasteMovementDefaultsPage
        config={{
            movementDirection: "Removed",
            listTitle: ListPageTitles.wasteRemoved,
            listPath: "/waste-removed",
            defaultsPath: "/waste-removed/defaults",
            siteStorageKey: "WasteRemovedDefaultsPage.siteId",
        }}
    />
);

export { WasteRemovedDefaultsPage };
